import React, {
  createContext,
  Dispatch,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";
import { Dialog, DialogContent, Box, IconButton } from "@mui/material";
import { useUsuario } from "../../../providers/usuarioProvider";
import TabelaDePrecos from "../../util/stripe/tabelaDePrecos";
import { IconX } from "@tabler/icons-react";
import Functions from "../../../callable/functions";

const initialState = false;

const AssinaturaModalReducer = (
  state: boolean,
  action: {
    type: "ABRIR_MODAL" | "FECHAR_MODAL";
  }
) => {
  switch (action.type) {
    case "ABRIR_MODAL":
      return true;
    case "FECHAR_MODAL":
      return false;
    default:
      return state;
  }
};

const AssinarStore = ({ children }: { children: React.ReactNode }) => {
  const { usuario } = useUsuario();
  const [open, dispatch] = useReducer(AssinaturaModalReducer, initialState);
  const [customerSessionClientSecret, setCustomerSessionClientSecret] =
    useState("");
  const handleClose = () => {
    dispatch({ type: "FECHAR_MODAL" });
  };

  useEffect(() => {
    if (open) {
      new Functions()
        .obterTabelaDePrecos()
        .then(({ data }) =>
          setCustomerSessionClientSecret(data.customerSessionClientSecret)
        );
    }
  }, [open]);

  return (
    <AssinarContext.Provider value={() => dispatch({ type: "ABRIR_MODAL" })}>
      <Dialog
        open={open && !!customerSessionClientSecret}
        onClose={handleClose}
        fullScreen
        PaperProps={{
          // Em fullScreen não há painel flutuante: nada de borda, raio ou
          // sombra de overlay — é a própria página.
          sx: {
            backgroundColor: "background.default",
            border: "none",
            borderRadius: 0,
            boxShadow: "none",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          p={1}
        >
          <IconButton onClick={handleClose} sx={{ color: "text.secondary" }}>
            <IconX />
          </IconButton>
        </Box>
        <DialogContent>
          {!!usuario && (
            <TabelaDePrecos
              customerSessionClientSecret={customerSessionClientSecret}
            />
          )}
        </DialogContent>
      </Dialog>
      {children}
    </AssinarContext.Provider>
  );
};

const AssinarContext = createContext<Dispatch<void>>(() => {});

export const useAssinar = () => {
  const context = useContext(AssinarContext);
  return context;
};

export default AssinarStore;
